export default __webpack_public_path__ + "static/media/products-icon-active.b69cb7f0.svg";